<app-modal #leaveConfirmationModal [modalConfig]="{ modalTitle: '', isFooterAllowed: false, isHeaderAllowed: false }">
    <div class="alert alert-dismissible d-flex flex-center flex-column pt-8 px-0">
        <mat-icon class="leave-warning-icon">warning</mat-icon>

        <div class="text-center mt-10">
            <p class="fw-bold mb-5" [ngClass]="isLegacyDeviceManagementMode ? 'fs-1' : 'fs-3'" [innerHTML]="config.message">
            </p>

            <div class="d-flex flex-center flex-wrap">
                <a class="btn btn-secondary m-2" (click)="dismiss()">{{ config.cancelButtonLabel }}</a>
                <a class="btn btn-primary m-2" (click)="close()">
                    {{ config.confirmButtonLabel }}
                </a>
            </div>
        </div>
    </div>
</app-modal>
